"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var currencyContextState = {
    isChangeCurrency: false,
    setIsChangeCurrency: function () { return undefined; },
};
var CurrencyContext = react_1.createContext(currencyContextState);
exports.default = CurrencyContext;
